import api from '@/lib/api/axios'

export interface VaultItem {
    id: number
    vaultId: string
    description: string
    region: string
    regionName: string
    operationalStatus: string
    buildAction: string | null
    buildStatus: string | null
    objectCount: number
    versionCount: number
    size: number
    analytics: boolean
    bandwidth: number
    latencyPercentage: number
    tcpPercentage: number
    encryptionPercentage: number
    created: string | null
}

export interface VaultRegion {
    code: string
    name: string
}

export interface ActiveScheduler {
    id: number
    schedulerId: string
    description: string
    hasPublicKey: boolean
}

export interface SetupSchedulerResponse {
    vaultConnectionToken: string
    vaultId: string
    vaultDescription: string
    schedulerId: string
    schedulerDescription: string
}

export const vaultsApi = {
    list: () =>
        api.get('/api/vaults'),

    create: (data: { description: string; region: string }) =>
        api.post('/api/vaults', data),

    update: (id: number, data: {
        description?: string
        analytics?: boolean
        bandwidth?: number
        latencyPercentage?: number
        tcpPercentage?: number
        encryptionPercentage?: number
    }) => api.put(`/api/vaults/${id}`, data),

    getRegions: () =>
        api.get('/api/vaults/regions'),

    getActiveSchedulers: () =>
        api.get('/api/vaults/active-schedulers'),

    setupScheduler: (vaultId: number, schedulerId: string) =>
        api.post(`/api/vaults/${vaultId}/setup-scheduler`, { schedulerId }),
}
